export function uniqueAssetEditors(mutations) {
  if (!Array.isArray(mutations) || mutations.length === 0) {
    return [];
  }
  const sorted = [...mutations].sort((a, b) => {
    const ta = String(a && a.mutated_at ? a.mutated_at : '');
    const tb = String(b && b.mutated_at ? b.mutated_at : '');
    if (tb !== ta) {
      return tb.localeCompare(ta);
    }
    return (Number(b && b.id) || 0) - (Number(a && a.id) || 0);
  });
  const seen = new Set();
  const out = [];
  for (const mutation of sorted) {
    if (!mutation || mutation.user_id == null || mutation.user_id === '') {
      continue;
    }
    const key = String(mutation.user_id);
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    out.push(mutation);
  }
  return out;
}

export function editorDisplayName(user, unknownLabel) {
  const fallback = unknownLabel || 'Unknown';
  if (!user || typeof user !== 'object') {
    return fallback;
  }
  const first = String(user.first_name || '').trim();
  const last = String(user.last_name || '').trim();
  if (first && last && first !== last) {
    return `${first} ${last}`;
  }
  if (first) {
    return first;
  }
  if (last) {
    return last;
  }
  if (user.username) {
    return user.username;
  }
  return fallback;
}
